import './_simple-slider.scss';
import './_simple-slider.twig';

import $ from 'jquery';
import 'slick-carousel';

import 'slick-carousel/slick/slick.scss';
import LayoutShiftEvent from '../../00-protons/events/layout-shift-event';

export const name = 'simple-slider';

export function disable() {}

const simpleSliderSelector = '.simple-slider';

export function enable(context) {
  Array.from(context.querySelectorAll(simpleSliderSelector)).forEach(
    (simpleSlider) => {
      const $slider = $(simpleSlider);

      const dispatchLayoutShift = () => {
        simpleSlider.dispatchEvent(new LayoutShiftEvent());
      };

      $slider.on('init', dispatchLayoutShift);
      $slider.on('reInit', dispatchLayoutShift);
      $slider.on('setPosition', dispatchLayoutShift);

      $slider.slick({
        prevArrow:
          '<button class="simple-slider__button simple-slider__button--prev">&#x25C0;&#xFE0E;</button>',
        nextArrow:
          '<button class="simple-slider__button simple-slider__button--next">&#x25B6;&#xFE0E;</button>',
      });
    },
  );
}

export default enable;
